import React from 'react';
import StarRating from '../../../basic/StarRating';
import { UserProfile } from '../../../../types/api/users';
import { AuthorResponse } from '../../../../types/api/common';
import { Stack, Avatar, Text, Label } from '@primer/react';

interface UserCardProps {
    user?: UserProfile;
    author?: AuthorResponse;
    isShowStatus: boolean
    avatarSize?: number;
    rating: number;
    nameFontSize: number
    ratingFontSize: number
    ratingHeight: number
    className?: string;
}

const UserCard: React.FC<UserCardProps> = ({
    user,
    author,
    isShowStatus = true,
    avatarSize = 64,
    rating = 0,
    nameFontSize = 20,
    ratingFontSize = 16,
    ratingHeight = 16,
    className = ""
}) => {
    const handleAvatarError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = "/icons/avatar.png";
    };

    const avatar = user?.avatar?.preview ?? author?.avatar?.preview
    const username = user?.username ?? author?.username

    return (
        <Stack direction="horizontal" align="center" className={className}>
            <Avatar
                src={avatar ?? "/icons/avatar.png"}
                alt="avatar"
                size={avatarSize}
                className={`w-[${avatarSize}px] aspect-square object-cover object-center rounded-full`}
                onError={handleAvatarError}
            />
            <Stack gap='none'>
                <Stack direction="horizontal" align="center">
                    <Text
                        as="span"
                        weight='medium'
                        className={`text-[${nameFontSize}px] text-aloix-black mr-2`}
                    >
                        {username}
                    </Text>
                    {isShowStatus && <Label
                        variant={user?.isBlocked ? 'danger' : 'success'}
                        size="small"
                    >
                        {user?.isBlocked ? 'Заблокированный' : 'Активный'}
                    </Label>}
                </Stack>
                <Stack direction="horizontal" align="center">
                    <Text
                        as="span"
                        weight='medium'
                        className={`text-[${ratingFontSize}px] text-aloix-black mr-[7px]`}
                    >
                        {rating}
                    </Text>
                    <StarRating
                        rating={rating}
                        size={ratingHeight}
                    />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default UserCard;